export const locale = {
  lang: 'en',
  data: {
    MENU: {
      HOME: {
        SECTION: 'Analysis',
        DASHBOARD_TASK: 'Dashboard Task',
      },
      EMISSIONDATA: {
        SECTION: 'Emission Data',
      },
      CALCULATION: {
        SECTION: 'Calculation',
        DATA: 'Data',
        DATAHISTORY: 'Emission Data History',
        DATALASTYEARS: 'Emission Data Last Years',
        BULK_UPLOAD: 'Bulk Data Upload',
        EMISSION_FACTOR_CONSTANTS: 'Emission Factor Constants',
        SOURCE_EMISSION_FACTORS: 'Source emission factors',
        LOGISTIC_FACTORS: 'Logistic emission factors',
        BUSINESS_TRAVEL_AIRWAY: 'Business Travel Airway Transport',
        EMISSION_FACTORS: 'Emission Factors',
        HOTEL_ACCOMMODATION_EMISSIONS: 'Hotel Accommodation Emissions',
      },
      ACCOUNTING: {
        SECTION: 'Accounting',
        EMISSION: 'Trial Balance',
        TREE: 'Account Tree',
        COA_SETUP: 'Chart of Accounts',
        LEDGER: 'Sub-ledger Center',
        RULES: 'Rule Library',
        EF: 'EF Library',
        EF_CONSOLE: 'EF Console',
        RESULTS: 'Results',
        AUX_LEDGERS: 'Auxiliary Ledgers',
        CONSOLIDATION: 'Consolidation',
      },
      EMISSION_SOURCE_CREATION: {
        SECTION: 'Emission Source Creation',
      },
      EMISSION_CATEGORY_METHODS: 'Category Methods',
      CONVERSION_PARAMETERS: 'Conversion Parameters',
      EMISSION_FACTOR_V2: {
        SECTION: 'EmissionFactor V2',
        STATIONARY_COMBUSTION: 'Stationary combustion factors',
        MOBILE_COMBUSTION: 'Mobile combustion factors',
        PURCHASED_ELECTRICITY: 'Purchased electricity factors',
      },
      ADMIN: {
        SECTION: 'Management',
        MYCOMPANY: 'My Company',
        USERMANAGEMENT: 'User Management',
        ROLES: 'Roles',
        LOCATIONS: 'Locations',
        SUBCOMPANY: 'Sub Companies',
        EQUIPMENTS: 'Equipments',
        WASTEWATERTREATMENT: 'Wastewater Treatment Facilities',
      },
      SUPERADMIN: {
        SECTION: 'Analysis',
      },
      APPLICATIONADMIN: {
        SECTION: 'Group Companies',
      },
      APPLICATIONMANAGEMENT: {
        SECTION: 'Applications',
        APPLICATIONS: 'Applications',
        LDAPSETTINGS: 'LDAP Settings',
        LOGINAUDITLOG: 'Login Audit Log',
        AIRCRAFT: 'Aircraft Types',
        AVIATIONFUELALIASES: 'Aviation Fuel Aliases',
      },
      AUTHORIZATION: {
        SECTION: 'Authorization',
        OVERVIEW: 'Overview',
        PERMISSIONS: 'Permissions',
        ROLES: 'Roles',
        ENDPOINTS: 'API Endpoints',
      },
      INTEGRATIONS: {
        SECTION: 'Integrations',
      },
      SUPPLIERSS: {
        SECTION: 'Suppliers',
      },
      WATER_FOOTPRINT: {
        SECTION: 'Water Footprint',
        TITLE: 'Water Footprint',
      },
      REPORTS: {
        SECTION: 'Reports',
        EMISSION: 'Emission Report',
        EMISSION_BY_CATEGORY: 'Emission Data By Category',
        UNCERTAINTY: 'Uncertainty Report',
        CREATE: 'Create Report',
        REPORT: 'Reporting',
      },
      TESTMENU: {
        HEADER: 'Menu Header',
        SECTION: 'Dropdown Menu',
        SUBMENU: 'Sub Menu 1',
        SUBMENU2: 'Sub Menu 2',
        SUBMENU2SUB: {
          TESTSUBMENU: 'Test Sub Menu',
          TESTSUBMENU2: 'Test Sub Menu 2',
        },
      },
    },
  },
};
